import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-03c05f39"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "auth"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fadeInUp"
}, "安全专业认证", -1));
const _hoisted_3 = {
  class: "auth-container fadeInUp"
};
const _hoisted_4 = ["data"];
import { reactive } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const data = reactive([{
      imgSrc: require('@/assets/img/auth/cert1.svg')
    }, {
      imgSrc: require('@/assets/img/auth/cert2.svg')
    }, {
      imgSrc: require('@/assets/img/auth/cert3.svg')
    }, {
      imgSrc: require('@/assets/img/auth/cert4.svg')
    }, {
      imgSrc: require('@/assets/img/auth/cert5.svg')
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createElementVNode("object", {
          type: "image/svg+xml",
          data: item.imgSrc
        }, null, 8, _hoisted_4)]);
      }), 128))])]);
    };
  }
};